import React from 'react';
import { Button, Heading } from '@superops/ui-design-system';
import envConfig from '@nile/home/src/Config/env';

interface EmptyStateProps {
  imageSrc?: string;
  headingText: string;
  buttonText: string;
  onButtonClick: () => void;
  disabled?: boolean;
}

function EmptyState({
  imageSrc = `${envConfig.imageRoot}svg/configuration.svg`,
  headingText,
  buttonText,
  onButtonClick,
  disabled = false
}: EmptyStateProps) {
  return (
    <div className="flex col actr jctr fhp g20">
      <img className="mr8" src={imageSrc} />
      <Heading element="h2" weight="SemiBold">
        {headingText}
      </Heading>
      <Button primary size="medium" onClick={onButtonClick} disabled={disabled}>
        {buttonText}
      </Button>
    </div>
  );
}

export default EmptyState;
